import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 border-t border-gray-200 bg-white text-center text-gray-500 text-xs sm:text-sm" data-id="element-61">
      <div className="max-w-2xl mx-auto space-y-2" data-id="element-62">
        <p className="font-bold text-swiss-charcoal" data-id="element-63">W&R Master-System 2026</p>
        <p data-id="element-64">🇨🇭 Schweiz | 100% Lehrplan 21 Konform</p>
        <p data-id="element-65">© 2026 — Alle Rechte vorbehalten.</p>
      </div>
    </footer>;
}